import { rem } from 'polished'
import { FormattedMessage } from 'react-intl'
import styled, { css } from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'

type InfiniteWordmarkSize = 'small' | 'large'

interface WordmarkProps {
  $size: InfiniteWordmarkSize
}

const Wordmark = styled.span<WordmarkProps>`
  font-family: ${props => props.theme.font.secondaryAlternate.family};
  background: ${props => props.theme.palette.product.loyalty.infinite.gradientTertiaryBackground};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;

  ${props => props.$size === 'small' && css`
    font-size: ${rem(12)};
    line-height: ${rem(16)};
    letter-spacing: ${rem(1)};
  `}

  ${props => props.$size === 'large' && css`
    display: block;
    margin-top: ${rem(4)};
    font-size: ${rem(28)};
    line-height: ${rem(34)};
    letter-spacing: ${rem(4)};

    ${mediaQueryUp.tablet} {
      font-size: ${rem(36)};
      line-height: ${rem(40)};
    }
  `}
`

interface Props {
  className?: string
  size?: InfiniteWordmarkSize
}

function InfiniteWordmark(props: Props) {
  const { className, size = 'large' } = props

  return <Wordmark className={className} $size={size}>
    <FormattedMessage
      id="hXNkG9xEPwHp5wpIxEKS"
      defaultMessage="INFINITE"
      description="Infinite membership tier wordmark displayed in premium brand lockups"
    />
  </Wordmark>
}

export default InfiniteWordmark
